<template>
  <Button id="main-cta" as="link" :href="href" @click.native.prevent="handleClick">
    {{ label }}
  </Button>
</template>

<script lang="ts" setup>
import { rbgContentPageMainCtaClickedV100 } from "kaleido-event-tracker";
import { Button } from "prism";

export interface ContentPageMainCtaProps {
  href: string;
  label: string;
  openInNewWindow: boolean;
}

const props = defineProps<ContentPageMainCtaProps>();

const handleClick = () => {
  rbgContentPageMainCtaClickedV100({});

  if (props.openInNewWindow) {
    window.open(props.href, "_blank");
  } else {
    window.location.href = props.href;
  }
};
</script>
